import { Clickable, H2, H4, P, Well, Wrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';

import { SectionWrapper } from '../../styles';
import constants from '../../../../ahm-constants';
import DocIconSubsection from '../doc-icon-subsection';
import HorizontalRule from '../../../../elements/horizontal-rule';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

const icon = { name: 'chevron-right', position: 'right', size: 'extraSmall' };

type DocIconSectionProps = {
  calloutInfo?: boolean;
  data: {}[];
  description?: string;
  link: string;
  title: string;
};

const DocIconSection = ({ calloutInfo = false, data, description, link, title }: DocIconSectionProps) => (
  <SectionWrapper id={link}>
    <Wrapper>
      <HorizontalRule className={styles.hr} />
      <H2>{title}</H2>
      {description && <P>{description}</P>}
      {calloutInfo && (
        <Well>
          <H4>Save trees and do it online!</H4>
          <P>Don’t fire up the printer. Just hit the links below to log in and be directed to:</P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.CLAIMS}>
              Make a claim
            </Clickable>
          </P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.MAKE_A_PAYMENT}>
              Make a once off payment
            </Clickable>
          </P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.PAYMENTS}>
              Set up direct debit
            </Clickable>
          </P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.PAYMENT_DETAILS}>
              Change payment details
            </Clickable>
          </P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.CLAIMS_PAYMENTS}>
              Change the account we pay claims into
            </Clickable>
          </P>
          <P>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ name: string; position: string; size: string; }' is not assignable to type '{ name: string; position?: "top" | "left" | "right" | undefined; size?: string | undefined; }'. */}
            <Clickable icon={icon} to={constants.URLS.MEMBERS.AGR}>
              Apply for the Australian Government Rebate
            </Clickable>
          </P>
        </Well>
      )}
      {uncapFpIterator(map)(
        // @ts-expect-error - Automatic, Please fix when editing this file
        (doc, index) => (
          <DocIconSubsection key={index} {...doc} />
        ),
        data,
      )}
    </Wrapper>
  </SectionWrapper>
);

export default DocIconSection;
